import React from 'react';

const Blog = () => {
    return (
        <div>
            <h3 className="flex justify-center my-48 text-3xl font-bold">Coming Soon.....</h3>
        </div>
    );
};

export default Blog;